import { IGetToolAction } from "@/actions/ai-configuration/tool/types";
import { useTranslations } from "next-intl";

interface AiConfigurationDetailsProps {
  data: IGetToolAction["Response"];
}

const ToolDetails = ({ data }: AiConfigurationDetailsProps) => {
  const t = useTranslations("tools");

  return (
    <div className="p-4 border-b w-full text-sm">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <p className="font-semibold text-gray-500">Nome</p>
          <p className="break-words">{data.name || "Não informado"}</p>
        </div>

        <div>
          <p className="font-semibold text-gray-500">URL</p>
          <p className="break-words">{data.apiUrl || "Não informado"}</p>
        </div>

        <div>
          <p className="font-semibold text-gray-500">Método</p>
          <p>{data.methodType || "Não informado"}</p>
        </div>

        <div className="mt-4">
          <p className="font-semibold text-gray-500">Tipo</p>
          <p>{t(`types.${data.type}`) || "Não informado"}</p>
        </div>
      </div>

      <div className="mt-4">
        <p className="font-semibold text-gray-500">Descrição</p>
        <div className="mt-1 whitespace-pre-wrap break-words max-h-[40vh] overflow-auto p-3 rounded-md bg-muted/5 border">
          {data.description || "Não informado"}
        </div>
      </div>
    </div>
  );
};

export default ToolDetails;
